import { computed, type ComputedRef } from 'vue';
import { useHead } from '@unhead/vue';
import type { Faq } from '@/shared/api/experience';

export function useSchemaFaq(seo: ComputedRef<Faq>) {
  const transformAnswerToString = (answer: string): string => {
    const plainText = answer?.replace(/<[^>]*>/g, '')?.trim();

    return plainText || answer;
  };

  const faqSchema = computed(() => {
    const mainEntity = seo.value.items?.map((item) => {
      const obj = {
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: transformAnswerToString(item.answer || ''),
        },
      };

      if (item.links?.length) {
        const hasPartContent = item.links.map((link) => {
          return {
            '@type': 'WebPage',
            name: link?.text || '',
            url: link?.url || '',
          };
        });

        return {
          ...obj,
          hasPart: {
            '@type': 'WebPage',
            itemListElement: hasPartContent,
          },
        };
      }

      return obj;
    });

    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: mainEntity,
    };
  });

  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: computed(() => JSON.stringify(faqSchema.value)),
        key: 'schema-faq',
      },
    ],
  });
}
